<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-21 15:39:14
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:35:04
-->

<template>
  <div class="innovative innovative-aneuflow" :class="{textj: language != 'en'}" ref="aneuflow">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div v-if="language == 'en'" class="innovative-bj-title center_up_down_left_right">
        <p v-html="$t('product.aneuflow.title').replace(' Hemodynamic', '<br />Hemodynamic')"></p>
      </div>
      <div v-else class="innovative-bj-title center_up_down_left_right" v-html="$t('product.aneuflow.title')"></div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.aneuflow.list[0].title')"></div>
      </div>
      <div class="p-t-28 p-l-2 p-r-10">
        <img class="wid100" :src="$t('product.aneuflow.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="item, index in $t('product.aneuflow.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="aneuflow-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.aneuflow.list[1].title')"></div>
          <div class="aneuflow-characteristics-box">
            <div class="p-t-30 p-b-30" v-for="item, index in $t('product.aneuflow.list[1].des')" :key="index">
              <div class="innovative-wrap-item-title fz-30 p-b-20" v-html="item.title"></div>
              <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{'innovative-container': language !== 'en'}">
      <div class="aneuflow-advantages p-t-20">
        <div class="innovative-item-title" v-html="$t('product.aneuflow.list[2].title')"></div>
        <div class="flex flex_wrap p-b-20 innovative-aneuflow-m-h">
          <p class="aneuflow-advantages-list" v-for="item, index in $t('product.aneuflow.list[2].des')" :key="index" v-html="item.title"></p>
        </div>
        <img class="wid100" :src="$t('product.aneuflow.list[2].m_img1')" alt="" srcset="">
      </div>
    </div>
    <div class="innovative-container">
      <div class="p-t-30 article">
        <div class="innovative-item-title" v-html="$t('product.aneuflow.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.aneuflow.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-aneuflow {
  .aneuflow-characteristics {
    background-image: url('~@/assets/images/innovate/AneuFlow/m_2.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .aneuflow-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 20px 40px;
    }
  }
  .aneuflow-advantages {
    .aneuflow-advantages-list {
      font-weight: 600;
      width: 50%;
      position: relative;
      padding: 20px 0 20px 56px;
      &::before {
        content: '';
        position: absolute;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        display: block;
        top: 21px;
        left: 0;
        background: #038ac3;
      }
      &:nth-of-type(2) {
        &::before {
          background: #2f7aed;
        }
      }
      &:nth-of-type(3) {
        &::before {
          background: #00b8a8;
        }
      }
      &:nth-of-type(4) {
        &::before {
          background: #0388ff;
        }
      }
    }
  }
}
.m.en .innovative-aneuflow {
  .aneuflow-advantages {
    background: #F8FBFF;
    border-radius: 8px;
    padding-bottom: 50px;
    padding: 50px 30px;
    .aneuflow-advantages-list {
      width: 100%;
    }
    .innovative-aneuflow-m-h {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 30px;
      margin-bottom: 20px;
      .m-h-sign {
        background: linear-gradient(90deg, #0556EA 0%, #02C2D0 100%);
        color: #ffffff;
        padding: 10px 21px;
        line-height: 38px;
      }
    }
  }
}
</style>
